// extracted by mini-css-extract-plugin
module.exports = {"titleText":"TitleText-module--title-text--3H-Sa","titleText__title":"TitleText-module--title-text__title--3tpNV","titleText__text":"TitleText-module--title-text__text--1Sfa_"};